import * as React from 'react';
import * as _ from 'lodash';
import ProjectScopeCard from '../../components/ProjectScope/ProjectScopeCardNew';
import { cleanProps } from '../../utilities/props';
import { NewFeatureGroup } from '../../components/ProjectScope/NewFeatureGroup/index.js';
import { ImportFeatures } from '../../components/FeatureCreator/ImportFeatures';
import BlueDropDown from '../../components/PageLayout/DropDowns/BlueDropDown.js';
import { SortByMode } from '../../components/ProjectScope/SortByMode';
export default function () {
    function onItemClick1(AR, item) {
        this.props.setMode(item);
    }
    function repeatFeatureGroup2(AR, featureGroup, featureGroupIndex) {
        return React.createElement(ProjectScopeCard, {
            'key': featureGroupIndex + '_' + featureGroup.name,
            'featureGroup': featureGroup,
            'getFeatureCreatorLink': this.getFeatureCreatorLink
        });
    }
    function scopeAR3() {
        var AR = this.props.AR;
        return React.createElement('div', _.assign({}, cleanProps(this.props)), React.createElement('div', { 'className': 'pj-scope-sub-header' }, AR.isSiteAdmin(true) ? React.createElement('div', {
            'className': 'pj-scope-sub-header__left',
            'key': '830'
        }, React.createElement(ImportFeatures, {})) : null, this.props.showMode ? React.createElement('div', {
            'className': 'pj-scope-sub-header__right',
            'key': '946'
        }, React.createElement(SortByMode, {
            'onItemClick': onItemClick1.bind(this, AR),
            'selectedItem': this.props.mode
        })) : null), React.createElement.apply(this, [
            'div',
            { 'className': 'pj-scope-flex-container' },
            React.createElement(NewFeatureGroup, {}),
            _.map(this.props.updatedFeaturesGroups, repeatFeatureGroup2.bind(this, AR)),
            React.createElement('div', { 'className': 'pj-scope-lir pj-scope-lir-flex-dummy' }),
            React.createElement('div', { 'className': 'pj-scope-lir pj-scope-lir-flex-dummy' }),
            React.createElement('div', { 'className': 'pj-scope-lir pj-scope-lir-flex-dummy' }),
            React.createElement('div', { 'className': 'pj-scope-lir pj-scope-lir-flex-dummy' }),
            React.createElement('div', { 'className': 'pj-scope-lir pj-scope-lir-flex-dummy' })
        ]));
    }
    return scopeAR3.apply(this, []);
}